import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
export function Nutzungsbedingungen() {
  return <div className="min-h-screen bg-[#f4f2ee] font-sans text-[#1a1a1a] text-[14px]" data-id="element-410">
      <SiteHeader data-id="element-411" />

      <div className="max-w-[900px] mx-auto px-[20px] py-[40px]" data-id="element-412">
        <h1 className="text-[28px] font-bold text-[#1a1a1a] mb-[32px] border-b-[2px] border-[#c8c0b0] pb-[16px]" data-id="element-413">
          Nutzungsbedingungen
        </h1>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-414">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-415">
            1. Geltungsbereich
          </h2>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-416">
            Diese Nutzungsbedingungen gelten für die Nutzung des ViWe Forums
            (nachfolgend „Forum" genannt), das von Emerald Health Solutions Ltd.
            betrieben wird. Mit der Nutzung des Forums erklären Sie sich mit
            diesen Nutzungsbedingungen einverstanden.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-417">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-418">
            2. Registrierung und Nutzerkonto
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-419">
            2.1 Registrierung
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-420">
            Die Nutzung bestimmter Funktionen des Forums erfordert eine
            Registrierung. Bei der Registrierung sind wahrheitsgemäße Angaben zu
            machen. Sie verpflichten sich, Ihre Registrierungsdaten aktuell zu
            halten.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-421">
            2.2 Zugangsdaten
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-422">
            Sie sind verpflichtet, Ihre Zugangsdaten geheim zu halten und vor
            dem Zugriff durch Dritte zu schützen. Sollten Sie Kenntnis von einem
            Missbrauch Ihres Nutzerkontos erlangen, sind Sie verpflichtet, uns
            unverzüglich zu informieren.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-423">
            2.3 Mindestalter
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-424">
            Die Nutzung des Forums ist nur Personen gestattet, die das 18.
            Lebensjahr vollendet haben.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-425">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-426">
            3. Nutzungsregeln
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-427">
            3.1 Zulässige Nutzung
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-428">
            Das Forum dient dem Austausch von Informationen und Erfahrungen zu
            Gesundheitsthemen. Die Nutzer verpflichten sich zu einem
            respektvollen und sachlichen Umgang miteinander.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-429">
            3.2 Verbotene Inhalte
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[12px]" data-id="element-430">
            Es ist untersagt, folgende Inhalte zu veröffentlichen:
          </p>
          <ul className="list-disc list-inside space-y-[6px] text-[14px] leading-[1.7] mb-[16px] ml-[16px]" data-id="element-431">
            <li data-id="element-432">
              Beleidigende, diffamierende oder diskriminierende Äußerungen
            </li>
            <li data-id="element-433">Gewaltverherrlichende oder pornografische Inhalte</li>
            <li data-id="element-434">Spam, Werbung oder kommerzielle Angebote ohne Genehmigung</li>
            <li data-id="element-435">Inhalte, die gegen geltendes Recht verstoßen</li>
            <li data-id="element-436">Persönliche Daten Dritter ohne deren Einwilligung</li>
            <li data-id="element-437">Falsche oder irreführende medizinische Informationen</li>
            <li data-id="element-438">Urheberrechtlich geschützte Werke ohne Berechtigung</li>
          </ul>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-439">
            3.3 Medizinische Hinweise
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-440">
            Die im Forum geteilten Informationen und Erfahrungen ersetzen keine
            professionelle medizinische Beratung, Diagnose oder Behandlung.
            Nutzer sollten bei gesundheitlichen Fragen oder Beschwerden stets
            einen qualifizierten Arzt konsultieren.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-441">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-442">
            4. Rechte und Pflichten des Betreibers
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-443">
            4.1 Moderation
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-444">
            Der Betreiber behält sich das Recht vor, Beiträge zu moderieren, zu
            bearbeiten oder zu löschen, wenn diese gegen die Nutzungsbedingungen
            verstoßen oder aus anderen wichtigen Gründen.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-445">
            4.2 Sperrung und Löschung
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-446">
            Bei Verstößen gegen diese Nutzungsbedingungen kann der Betreiber
            Nutzerkonten vorübergehend oder dauerhaft sperren oder löschen. Ein
            Anspruch auf Nutzung des Forums besteht nicht.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-447">
            4.3 Verfügbarkeit
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-448">
            Der Betreiber bemüht sich um eine möglichst unterbrechungsfreie
            Verfügbarkeit des Forums. Ein Anspruch hierauf besteht jedoch nicht.
            Der Betreiber behält sich das Recht vor, das Forum jederzeit zu
            ändern, einzuschränken oder einzustellen.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-449">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-450">
            5. Urheberrecht und Nutzungsrechte
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-451">
            5.1 Nutzerinhalte
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-452">
            Mit dem Einstellen von Inhalten im Forum räumen Sie dem Betreiber
            ein einfaches, räumlich und zeitlich unbeschränktes Nutzungsrecht an
            diesen Inhalten ein. Dies umfasst insbesondere das Recht zur
            Vervielfältigung, Verbreitung und öffentlichen Zugänglichmachung.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-453">
            5.2 Rechte Dritter
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-454">
            Sie versichern, dass Sie über alle erforderlichen Rechte an den von
            Ihnen eingestellten Inhalten verfügen und keine Rechte Dritter
            verletzen.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-455">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-456">
            6. Haftung
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-457">
            6.1 Haftungsbeschränkung
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-458">
            Der Betreiber haftet nur für Schäden, die auf einer vorsätzlichen
            oder grob fahrlässigen Pflichtverletzung beruhen. Dies gilt nicht
            für Schäden aus der Verletzung des Lebens, des Körpers oder der
            Gesundheit.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-459">
            6.2 Nutzerinhalte
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-460">
            Der Betreiber übernimmt keine Haftung für die Richtigkeit,
            Vollständigkeit oder Aktualität der von Nutzern eingestellten
            Inhalte. Die Verantwortung für diese Inhalte liegt ausschließlich
            bei den jeweiligen Nutzern.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-461">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-462">
            7. Änderungen der Nutzungsbedingungen
          </h2>
          <p className="text-[14px] leading-[1.7]" data-id="element-463">
            Der Betreiber behält sich das Recht vor, diese Nutzungsbedingungen
            jederzeit zu ändern. Registrierte Nutzer werden über Änderungen per
            E-Mail informiert. Widersprechen Sie den Änderungen nicht innerhalb
            von vier Wochen nach Bekanntgabe, gelten die geänderten
            Nutzungsbedingungen als akzeptiert.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-464">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-465">
            8. Schlussbestimmungen
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-466">
            8.1 Anwendbares Recht
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-467">
            Es gilt das Recht der Republik Irland unter Ausschluss des
            UN-Kaufrechts.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-468">
            8.2 Salvatorische Klausel
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-469">
            Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam
            sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen
            hiervon unberührt.
          </p>
        </div>

        <div className="bg-[#fff9e6] border border-[#e8c84a] rounded-[6px] p-[20px]" data-id="element-470">
          <p className="text-[12px] text-[#666] leading-[1.6]" data-id="element-471">
            <strong data-id="element-472">Stand:</strong> April 2026
          </p>
        </div>
      </div>

      <SiteFooter data-id="element-473" />
    </div>;
}